import "../../css/map-loading-spinner.css";

interface IProps {
  style?: any;
  childrenStyle?: any;
}

const SpinnerBase = ({ style, childrenStyle }: IProps) => (
  <div className="spinner" style={style}>
    <div className="bounce1" style={childrenStyle}></div>
    <div className="bounce2" style={childrenStyle}></div>
    <div className="bounce3" style={childrenStyle}></div>
  </div>
);

export default SpinnerBase;
